export function convertListToString(list: string[]): string {
  return JSON.stringify(list).replace(/"/g, "'").toUpperCase();
}

export function convertStringToList(string: string): string[] | undefined {
  return string ? JSON.parse(string.replace(/'/g, '"').toLowerCase()) : undefined;
}